import { useContext } from 'react'

import { BoxLockContext } from './box-lock-context'

export function useModalContext() {
  const context = useContext(BoxLockContext)
  if (context.componentType !== 'modal') {
    throw new Error('useModalContext should be used with a modal component')
  }
  return context
}
